import '../../../../packages/neb-www-booking/src/components/neb-booking-appointment-details';
import '../../../../packages/neb-lit-components/src/components/neb-button';

import { LitElement, html, css } from 'lit';

import { getBookingAppointment } from '../../../../packages/neb-api-client/src/appointment-api-client';
import { openError } from '../../../../packages/neb-dialog/neb-banner-state';
import { connect, store } from '../../../../packages/neb-redux/neb-redux-store';
import { CSS_SPACING } from '../../../../packages/neb-styles/neb-variables';
import { TEXT_APPOINTMENT_NOT_EXIST } from '../../../../packages/neb-www-booking/src/components/appointment/neb-booking-appointment-page';
import { navigate } from '../../../store';
import {
  baseStyles,
  CSS_COLOR_HIGHLIGHT,
  CSS_FONT_SIZE_HEADER,
  CSS_FONT_WEIGHT_BOLD,
} from '../../../styles';

export const ELEMENTS = {
  returnHomeButton: { id: 'returnHomeButton' },
  appointmentDetails: { id: 'appointmentDetails' },
};

const TEXT_RETURN_HOME_BUTTON = 'RETURN HOME';

class NebBookingWalkInAppointmentPage extends connect(store)(LitElement) {
  static get properties() {
    return {
      __appointment: Object,
      __providers: Object,
      appointmentId: String,
      layout: {
        type: String,
        reflect: true,
      },
      user: Object,
    };
  }

  static get styles() {
    return [
      baseStyles,
      css`
        :host {
          display: flex;
          flex-direction: column;
          margin: 0 25px;
        }

        :host([layout='small']) {
          margin: 0;
        }

        .appointment-details {
          margin-top: ${CSS_SPACING};
          margin-bottom: ${CSS_SPACING};
        }

        .button-container {
          margin-top: 40px;
          display: flex;
          flex-wrap: wrap;
        }

        .button {
          flex-shrink: 0;
          margin-top: ${CSS_SPACING};
          margin-right: ${CSS_SPACING};
        }

        .title {
          font-size: ${CSS_FONT_SIZE_HEADER};
          color: ${CSS_COLOR_HIGHLIGHT};
          font-weight: ${CSS_FONT_WEIGHT_BOLD};
        }
      `,
    ];
  }

  get __hasRequestParams() {
    return this.__hasTenantId && this.__hasToken && this.appointmentId;
  }

  constructor() {
    super();

    this.__initState();
    this.__initHandlers();
  }

  __initState() {
    this.__appointment = {};
    this.__fetchedOnInitialLoad = false;
    this.__hasTenantId = false;
    this.__hasToken = false;
    this.__hasSession = false;

    this.appointmentId = '';
    this.layout = '';
    this.tenantPracticeInfo = {};

    this.onNavigateToLogin = () => {};
  }

  __initHandlers() {
    this.__handlers = {
      navigateToLandingPage: () => {
        navigate('#/');
      },
    };
  }

  __setProviders(state) {
    if (
      state.providers &&
      state.providers.item &&
      this.__providers !== state.providers.item
    ) {
      this.__providers = state.providers.item;
    }
  }

  __checkTenantId(state) {
    if (
      state.onlineBooking &&
      state.onlineBooking.item &&
      state.onlineBooking.item.tenantId
    ) {
      this.__hasTenantId = true;
    }
  }

  _stateChanged(state) {
    if (state.session && state.session.item) {
      this.__hasSession = true;
    }

    this.__setProviders(state);
    this.__checkTenantId(state);

    if (state.session.item && state.session.item.idToken) {
      this.__hasToken = true;
    }
  }

  async __fetchBookingAppointment() {
    try {
      this.__appointment = await getBookingAppointment(this.appointmentId);
    } catch (e) {
      store.dispatch(openError(TEXT_APPOINTMENT_NOT_EXIST));
      navigate('#/my-appointments');
    }
  }

  __getProvider() {
    if (!this.__providers) return {};
    return this.__providers.find(p => p.id === this.__appointment.providerId);
  }

  __getLocation() {
    if (!this.tenantPracticeInfo.locations || !this.__appointment.locationId) {
      return null;
    }

    const location = this.tenantPracticeInfo.locations.find(
      l => l.id === this.__appointment.locationId,
    );

    return this.tenantPracticeInfo.locations.length > 1 ? location : null;
  }

  updated() {
    if (!this.__fetchedOnInitialLoad && this.__hasRequestParams) {
      this.__fetchedOnInitialLoad = true;
      this.__fetchBookingAppointment();
    }

    if (!this.__hasRequestParams && !this.__hasSession && !this.__token) {
      this.onNavigateToLogin(`/walk-in-appointment/${this.appointmentId}`);
    }
  }

  render() {
    return html`
      <div class="appointment-container">
        <div id="title" class="title">You are checked-in!</div>

        <neb-booking-appointment-details
          id="${ELEMENTS.appointmentDetails.id}"
          class="appointment-details"
          .layout="${this.layout}"
          .appointment="${this.__appointment}"
          .provider="${this.__getProvider()}"
          .location="${this.__getLocation()}"
          showserviceinfo
        ></neb-booking-appointment-details>

        <div class="button-container">
          <neb-button
            id="${ELEMENTS.returnHomeButton.id}"
            class="button"
            label="${TEXT_RETURN_HOME_BUTTON}"
            @click="${this.__handlers.navigateToLandingPage}"
            outlined
          ></neb-button>
        </div>
      </div>
    `;
  }
}

customElements.define(
  'neb-booking-walk-in-appointment-page',
  NebBookingWalkInAppointmentPage,
);
